import React from 'react';
import "../../constants/styles/preSession.scss";
import { introPanelTexts, learnMoreText} from "../../constants/textContent.js";

const IntroPanel = ({ onContinue, onStartChat, showStartButton, updatedText }) => {
    return (
        <div className='pre-session-container'>
            <h1 className="intro">{updatedText ? introPanelTexts.beforeProceedTitle : introPanelTexts.welcomeTitle}</h1>
            <div className='text-panel'>
                <p className="exploring">{updatedText ? introPanelTexts.confirmationNotice : introPanelTexts.exploringTitle}</p>
                {updatedText ? null : <div className="blue-line"></div>}
                <p>{updatedText || introPanelTexts.description}</p>
                {!updatedText && (
                    <>
                        <p>{introPanelTexts.participationNotice}</p>
                        <p>{introPanelTexts.invitation}</p>
                    </>
                )}
            </div>
            <div className="button-container">
                {!showStartButton ? (
                    <button className="continue-button" onClick={onContinue}>
                        {introPanelTexts.continueButton}
                    </button>
                ) : (
                    <button className="start-chat" onClick={onStartChat}>
                        {introPanelTexts.startChatButton}
                    </button>
                )}
            </div>
        </div>
    );
};

export default IntroPanel;
